// extracted by mini-css-extract-plugin
export var container = "_95-1";
export var cornerButtonContainer = "_95-5";
export var disabled = "_95-2";
export var fileContainer = "_95-4";
export var hiddenInput = "_95-3";
export var widthContainer = "_95-0";